import { defineComponent } from "vue";
import { Modal } from "vue-neat-modal";
import IonIcon from "@/components/IonIcon.vue";
export default defineComponent({
  name: "Alert",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    alignY: {
      type: String,
      default: "center"
    },
    okText: {
      type: String,
      default: ""
    },
    LoadingText: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    clickOut: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: `alert`
    },
    hasClose: {
      type: Boolean,
      default: true
    },
    useHTML: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },

  mounted() {},

  //   emits: ['update:isOpen'],
  components: {
    Modal,
    IonIcon
  },
  methods: {
    ok() {
      this.$emit("ok");
    },

    cancel() {
      this.$emit("cancel");
    },

    close() {
      this.$emit("update:isOpen", false);
    },

    afterLeave() {
      this.$emit("afterLeave");
    },

    closeDialog(e) {
      this.$emit("update:isOpen", e);
    }

  }
});